import { styled } from "@mui/system";

export const AppContainer = styled("div")`
  margin: 24px auto 0 auto;
  padding-left: 16px;
  padding-right: 16px;
  max-width: 1024px;
`;
